import React from 'react';
import { Box, Input, Typography, makeStyles } from '@material-ui/core';
import { theme } from 'theme';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({
  textFieldContainer: {
    marginBottom: 20,
  },
  label: {
    fontSize: 14,
    lineHeight: '2.4rem',
    color: theme.palette.text.secondary,
  },
  input: {
    height: 40,
    width: '100%',
    flex: 1,
    padding: 10,
    backgroundColor: theme.palette.grey[400],
    borderRadius: 4,
    color: theme.palette.grey[800],
  },
});

interface TextFieldLabelProps {
  name: string;
  label: string;
  required?: boolean;
  value: string | number;
  type?: string;
  error?: boolean;
  onChange: (event: React.ChangeEvent) => void;
}

function TextFieldLabel({
  label,
  value,
  name,
  onChange,
  required = false,
  type = 'text',
  error = false,
}: TextFieldLabelProps) {
  const { t, i18n } = useTranslation();
  const classes = useStyles();

  return (
    <Box className={classes.textFieldContainer}>
      <Typography className={classes.label}>
        {label}
        {required && <span>( {t('required')} )</span>}
      </Typography>
      <Input
        name={name}
        className={classes.input}
        type={type}
        value={value}
        onChange={onChange}
        disableUnderline={!error}
        error={error}
      />
    </Box>
  );
}

export default TextFieldLabel;
